angular.module('core')
    .provider('dblAnalyticsPluginProvider', function() {

    var provider = {
        $get: ['$log', '$rootScope', '$state','dblAnalyticsApi', function($log, $rootScope, $state, dblAnalyticsApi) {

            var customerId = null;
            $rootScope.$on('customerInfoSet', function (event, customer) {
                customerId = customer.id;
            });

            function buildState(viewLevel, params) {
                return {
                    customerId: customerId,
                    districtId: params.districtId,
                    schoolId: params.schoolId,
                    teacherId: params.teacherId,
                    classroomId: params.classroomId,
                    studentId: params.studentId,
                    gradeId: params.gradeId,
                    view: params.subpane ? params.subpane : params.pane,
                    viewType: params.viewType,
                    viewLevel: viewLevel, //classroom vs student, etc.
                    tracking: params.tracking
                };
            }

            function getEventState() {
                if($state.params) {
                    var viewLevel = $state.current ? $state.current.name : undefined;
                    return buildState(viewLevel, $state.params);
                } else {
                    return {};
                }
            }

            function buildPageEvent(category, action, page, eventType, location, params) {
                var state = buildState(params.viewLevel, params);
                return angular.extend({},
                    {
                        value: page,
                        state: state
                    }, {
                        action: action,
                        eventType:eventType,
                        category:category
                    });
            }

            return {
                //analytics eventTrack
                //action - description of event captured
                //event object
                eventTrack: function(action, event) {
                    if(action && event) {
                        var e = angular.extend(event, { state: getEventState() }, { action: action });

                        if (!e.value && e.label && e.label !== "") {
                            e.value = e.label;
                        }
                        e.state.viewLevel = $state.current.name; // in case viewLevel not set in params
                        dblAnalyticsApi.logEvent(e);
                    }
                },

                //analytics pageTrack
                //page
                //event  object
                pageTrack: function(page, location, toParams, fromParams) {
                    if(page) {
                        //if user is leaving a tab, send the closing tracking event
                        if (fromParams && fromParams.tracking && fromParams.tracking.trackingFinishTimestamp) {
                            var endPaneView = buildPageEvent('route-state', 'view', page, 'state-change-finish', location, fromParams);
                            dblAnalyticsApi.logEvent(endPaneView);
                            fromParams.tracking = null;
                            return;
                        }

                        //track the current state route user entered
                        var startPaneView = buildPageEvent('route-state', 'view', page, 'state-change-start', location, toParams);
                        dblAnalyticsApi.logEvent(startPaneView);
                    }
                }
           };
        }]
    };

    return provider;
});
